import { render, staticRenderFns } from "./UcMailAccountSelector.yaml?vue&type=template&id=897fadd2&component"
import script from "./UcMailAccountSelector.yaml?vue&type=script&lang=ts&component"
export * from "./UcMailAccountSelector.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports